import { render } from "./TasksListView.vue?vue&type=template&id=4c761dfc&scoped=true&ts=true&lang=pug"
import script from "./TasksListView.vue?vue&type=script&lang=ts"
export * from "./TasksListView.vue?vue&type=script&lang=ts"

import "./TasksListView.vue?vue&type=style&index=0&id=4c761dfc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c761dfc"]])

export default __exports__